export default __webpack_public_path__ + "static/media/GenSekiGothicTW-R-01.e4d39aa9.woff2";